<div class="d-flex justify-content-between  align-items-center mb-6" *ngIf="valueFormGroup && valueFormControl">
  <label *ngIf="label" for="{{controlName}}"
         class="col-12 col-lg-4 col-form-label {{required ? 'required':''}}">{{label}}</label>
  <div class="col-12 col-lg-8 {{class}}" [formGroup]="valueFormGroup">
    <mat-select
      [formControlName]="controlName"
      (selectionChange)="handleChangeValue($event)"
      placeholder="{{placeholder}}"
      [errorStateMatcher]="matcher">
      <div *ngIf="options">
        <mat-option
          [disabled]="disable.value.includes(opt.value)"
          *ngFor="let opt of options"
          [value]="opt.value">
          {{
          (customNameWithId || opt.code)
            ? opt.code + ' - ' + opt.display
            : opt.display
          }}
        </mat-option>
      </div>
    </mat-select>
    <mat-error *ngIf="isNotValidAndDirty && hasErrors">
      {{controlName}} is required
    </mat-error>
  </div>
</div>


